export const isNotSaved = (state) => !!state.savedData.is_not_saved
export const getUsersSearchParams = (state) => state.users.searchParams
